import { IonIcon } from '@ionic/react';
import { addOutline } from 'ionicons/icons';
import { PHOTO_TILE_SIZE } from './PostPhotoThumb';

interface AddPhotoTileProps {
  onClick: () => void;
  disabled?: boolean;
}

/** Dashed "+" tile that adds a photo. */
export const AddPhotoTile = ({ onClick, disabled = false }: AddPhotoTileProps) => (
  <button
    type="button"
    className="flex shrink-0 items-center justify-center bg-transparent text-[#8a93a3] cursor-pointer disabled:cursor-default disabled:opacity-60"
    // Inline border: a global button reset overrides Tailwind's border utilities
    style={{
      width: PHOTO_TILE_SIZE,
      height: PHOTO_TILE_SIZE,
      borderRadius: '8px',
      border: '2px dashed #c9d0dc',
      padding: 0,
    }}
    onClick={onClick}
    disabled={disabled}
    aria-label="Añadir foto"
  >
    <IonIcon icon={addOutline} className="text-3xl" aria-hidden="true" />
  </button>
);
